export default {
  GET_STUDENT_OFFICE_HOURS_REQUEST: "GET_STUDENT_OFFICE_HOURS_REQUEST",
  GET_STUDENT_OFFICE_HOURS_SUCCESS: "GET_STUDENT_OFFICE_HOURS_SUCCESS",
  GET_STUDENT_OFFICE_HOURS_FAIL: "GET_STUDENT_OFFICE_HOURS_FAIL",

  GET_UPCOMING_OFFICE_HOURS_REQUEST: "GET_UPCOMING_OFFICE_HOURS_REQUEST",
  GET_UPCOMING_OFFICE_HOURS_SUCCESS: "GET_UPCOMING_OFFICE_HOURS_SUCCESS",
  GET_UPCOMING_OFFICE_HOURS_FAIL: "GET_UPCOMING_OFFICE_HOURS_FAIL",

  GET_OFFICE_HOURS_HISTORY_REQUEST: "GET_OFFICE_HOURS_HISTORY_REQUEST",
  GET_OFFICE_HOURS_HISTORY_SUCCESS: "GET_OFFICE_HOURS_HISTORY_SUCCESS",
  GET_OFFICE_HOURS_HISTORY_FAIL: "GET_OFFICE_HOURS_HISTORY_FAIL",

  APPLY_OFFICE_HOUR_REQUEST: "STUDENT_APPLY_OFFICE_HOUR_REQUEST",
  APPLY_OFFICE_HOUR_SUCCESS: "STUDENT_APPLY_OFFICE_HOUR_SUCCESS",
  APPLY_OFFICE_HOUR_FAIL: "STUDENT_APPLY_OFFICE_HOUR_FAIL",

  SET_STUDENT_OFFICE_HOURS_LOADING: "SET_STUDENT_OFFICE_HOURS_LOADING",
  SET_UPCOMING_OFFICE_HOURS_LOADING: "SET_UPCOMING_OFFICE_HOURS_LOADING",
  SET_OFFICE_HOURS_HISTORY_LOADING: "SET_OFFICE_HOURS_HISTORY_LOADING",
  SET_APPLY_OFFICE_HOUR_LOADING: "SET_APPLY_OFFICE_HOUR_LOADING",
};
